import { useAuthMutation, useQueryClient } from 'queries/query';
import { getQueryKeys } from 'queries/query-key';
import { KEY } from './keys';
import { AdminsApi } from 'api';
import { CreateAdminType } from 'types';

function useCreate() {
  const queryClient = useQueryClient();
  return useAuthMutation((data: CreateAdminType) => AdminsApi.post(data), {
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: getQueryKeys([KEY]).all });
    },
  });
}

export default useCreate;
